import(/* webpackMode: "eager" */ "/home/runner/work/vildarborn/vildarborn/app/[locale]/[...slug]/post-container.tsx")